import { Group, Stack } from "@mantine/core"
import dayjs from "dayjs"
import { useTranslations } from "../../utils/use-t"
import { CustomDateInput, CustomDateInputProps } from "./custom-date-input"

interface Props extends Pick<CustomDateInputProps, "variant"> {
  start: Date | undefined
  end: Date | undefined
  setStart: (newStart: Date | undefined) => void
  setEnd: (newEnd: Date | undefined) => void
  maxDate?: Date
  minDate?: Date
  required?: boolean
  makros?: React.ComponentType<RangePickerMakroProps>[]
  clearable?: boolean
}

export interface RangePickerMakroProps {
  start: Date | undefined
  end: Date | undefined
  setStart?: (newStart: Date | undefined) => void
  setEnd?: (newEnd: Date | undefined) => void
}

export function RangePicker({
  start,
  end,
  setStart,
  setEnd,
  maxDate,
  minDate,
  required,
  clearable,
  makros = [],
  variant,
}: Props) {
  const { appServer } = useTranslations()

  const handleStartDateChange = (newStart: Date | undefined) => {
    if (newStart && end && dayjs(newStart).isAfter(dayjs(end))) {
      setEnd(newStart)
    }
    setStart(newStart)
  }

  const handleEndDateChange = (newEnd: Date | undefined) => {
    if (newEnd && start && dayjs(newEnd).isBefore(dayjs(start))) {
      setStart(newEnd)
    }
    setEnd(newEnd)
  }

  return (
    <Stack>
      <Group wrap="nowrap">
        <CustomDateInput
          variant={variant}
          inputProps={{
            w: "50%",
          }}
          required={required}
          value={start}
          clearable={clearable}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(newDate) => handleStartDateChange(newDate ?? undefined)}
          label={appServer[0]("Start")}
          // dropdownChildren={[
          //   SeasonMakroSingleInput,
          //   CalendarWeekMakroSingleInput,
          // ]}
        />
        <CustomDateInput
          variant={variant}
          startOrEnd="end"
          inputProps={{
            w: "50%",
          }}
          required={required}
          clearable={clearable}
          minDate={minDate}
          maxDate={maxDate}
          value={end}
          onChange={(newDate) => handleEndDateChange(newDate ?? undefined)}
          label={appServer[0]("End")}
          // dropdownChildren={[
          //   SeasonMakroSingleInput,
          //   CalendarWeekMakroSingleInput,
          // ]}
        />
      </Group>
      {makros.map((MakroComponent, index) => (
        <MakroComponent
          key={index}
          start={start}
          end={end}
          setStart={handleStartDateChange}
          setEnd={handleEndDateChange}
        />
      ))}
    </Stack>
  )
}
